import React, { useState, Fragment } from "react";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import ComponentLoader from "../loader/ComponentLoader";
import GoogleMap from "../google/GoogleMap";
import Marker from "../google/Marker";
import InfoWindowSimple from "../google/InfoWindowSimple";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function MapPanel({ isLoadingDetails, mapDetails }) {
  const classes = useStyles();
  const [showMap, setShowMap] = useState(false);

  return (
    <Accordion expanded>
      <AccordionSummary
        aria-controls="adm-detail-content"
        id="adm-detail-header"
      >
        <Typography className={classes.heading}>Map</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="span" display="block" width="100%">
          <ComponentLoader isLoading={isLoadingDetails} />
          {!!mapDetails && !isLoadingDetails && (
            <Fragment>
              {!!showMap ? (
                <GoogleMap
                  id="google-map"
                  width="100%"
                  height="300px"
                  options={{
                    center: mapDetails.coordinates,
                    zoom: 8,
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                  }}
                >
                  <Marker
                    id="marker"
                    position={mapDetails.coordinates}
                    infoWindow={
                      <InfoWindowSimple
                        title={mapDetails.infoWindowTitle}
                        detail={mapDetails.infoWindowDetail}
                      />
                    }
                    defaultOpen
                  />
                </GoogleMap>
              ) : (
                <Box display="flex" flexDirection="row" justifyContent="center">
                  <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => setShowMap(true)}
                  >
                    Show
                  </Button>
                </Box>
              )}
            </Fragment>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
